export default "__VITE_ASSET__BTx98Whr__"